import {useEffect} from 'react';
import {getUrlParams} from '../common/getUrlParams';
import {openWindow} from '../common/openWindow.function';
import {requestContext} from '../common/requestContext';
import {OPEN_NEW_WINDOW_PARAM_KEY} from '../domain/bridge/applink/constant';

/**
 * 쿼리스트링에 pnwindow 가 있을 경우 해당 팝업을 띄웁니다
 * 이 hook 이 필요한 이유는 link-page 에 buy_cash 같은 팝업으로 띄워줘야하는 스킴이 왔을 때 랜딩할 곳이 없기 때문입니다. 일단 메인을 띄운 뒤 해당 윈도우 팝업을 띄웁니다
 */
export function useHandleOpenNewWindowQuery() {
  useEffect(() => {
    const {search} = window.location;
    const {params} = getUrlParams(search);
    if (
      !requestContext.requestInfo.display.isWebView && // 웹뷰에선 팝업을 띄우지 않습니다. (pcsme 값이 있다면 useTryScheme 통해 스킴이 실행됨)
      Object.prototype.hasOwnProperty.call(params, OPEN_NEW_WINDOW_PARAM_KEY)
    ) {
      const fullUrl = params[OPEN_NEW_WINDOW_PARAM_KEY] as string;
      openWindow({
        url: fullUrl,
        target: fullUrl,
        features: 'width=460, height=700',
      });
    }
  }, []);
}
